import { theme, parse } from "@config/theme";
import { css } from "linaria";
import { rem } from "polished";
export const container = parse({
  position: "relative",
  pb: {
    medium: "56"
  }
}, "cq6qlbq");
export const imageContainer = parse({
  position: "relative",
  width: "100%"
}, "ibak3u9");
export const image = parse({
  position: "absolute",
  width: "100%",
  height: "100%"
}, "irb494f");
export const contentContainer = parse({
  bg: "shade900",
  py: {
    _: "32",
    medium: "40"
  },
  px: {
    _: "16",
    medium: "40"
  },
  position: {
    medium: "absolute"
  }
}, "c1h8ar0b");

require("./ImageBannerText.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ImageBannerText.styles.ts");